import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ClientErrorReporter } from './client-error-reporter.service';
import { isPermissionDenied, PermissionDeniedReporter, wasReported } from './permission-denied-reporter.service';

/**
 * Reports every error no caller handled, then defers to Angular's default handler.
 *  - Firestore rule denials (listeners without an error callback, rejected promises, queries that
 *    bypass FirestoreService) go to the permission-denied report.
 *  - Everything else goes to ClientErrorReporter.
 */
@Injectable()
export class ClientTelemetryErrorHandler extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  handleError(error: any): void {
    try {
      // Resolved lazily: HttpClient/Router depend on services that may themselves report errors here.
      if (isPermissionDenied(error)) {
        if (!wasReported(error)) {
          this.injector.get(PermissionDeniedReporter).report(undefined, 'unknown', error);
        }
      } else {
        // An unhandled promise rejection arrives wrapped; the rejection is the error that matters.
        const cause = error?.rejection ?? error;
        this.injector.get(ClientErrorReporter).report(cause instanceof HttpErrorResponse ? 'http' : 'uncaught', cause);
      }
    } catch {
      // Telemetry must never break error handling.
    }
    super.handleError(error);
  }
}
